<template lang="pug">
  .navbar__desktop
    transition(name="fade")
      .navbar__desktop__overlay(v-if="subnav", @click="hideSearch")
    .navbar__desktop__wrapper
      .container.container--nav
        .navbar__left
          slot(name="logo")
          .navbar__links
            ul.navbar__linklist
              li.navbar__linklist__link.navbar__linklist__link--text(v-for="link in links", :key="link.title")
                a.navbar__link(
                  :href="cleanURL(link.url)"
                  @mouseenter="showSubnav(link.handle)"
                  @focus="showSubnav(link.handle)"
                  v-if="link.children"
                ) {{ link.title }}
                a.navbar__link(
                  :href="cleanURL(link.url)"
                  @mouseenter="hideSubnav"
                  @focus="hideSubnav"
                  v-else
                ) {{ link.title }}
                transition(name="fade", v-if="link.children")
                  .navbar__subnav(:key="link.handle", v-if="subnav && subnav === link.handle", @mouseleave="hideSubnav")
                    .container.navbar__subnav__container
                      a.navbar__subnav__link(
                        :href="cleanURL(childLink.url)",
                        v-for="childLink in link.children",
                        :key="childLink.title"
                      ) {{ childLink.title }}
        .navbar__right(
          :class="{ 'search-open': subnav && subnav === 'search' }"
        )
          .navbar__search
            icon-button.navbar-search__submit(
              v-if="subnav && subnav === 'search'"
              icon="close"
              width="22px"
              height="20px"
              label="Close Search"
              @click="hideSubnav()"
            )
            icon-button.navbar-search__submit(
              v-else
              :icon="getSearchIcon"
              width="22px"
              height="20px"
              label="Search"
              @click="showSubnav('search')"
              @mouseover.native="searchHighlighted = true"
              @mouseleave.native="searchHighlighted = false"
            )
          ul.navbar__linklist
            li.navbar__linklist__link
              icon-link.navbar__linklist__link--user(
                :icon="getUserIcon"
                width="17px"
                height="22px"
                :href="this.userLink"
                :label="userLabel"
                @mouseover.native="userHighlighted = true"
                @mouseleave.native="userHighlighted = false"
              )
            li.navbar__linklist__link
              navbar-cart
        .navbar__subnav(
          v-if="subnav && subnav === 'search'",
          @mouseenter="overSearchResults = true",
          @mouseleave="overSearchResults = false"
        )
          navbar-search(
            ref="searchBox",
            :suggestedSearches="suggestedSearches"
            @open-results="showSubnav('search')",
            @close-results="onCloseResults"
          )
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';
  import IconButton from 'scripts/components/buttons/IconButton.vue';
  import IconLink from 'scripts/components/buttons/IconLink.vue';
  import NavbarSearch from 'scripts/components/navigation/NavbarSearch.vue';
  import NavbarCart from 'scripts/components/navigation/NavbarCart.vue';

  export default {
    name: 'NavbarDesktop',
    components: { Icon, IconButton, NavbarSearch, NavbarCart, IconLink },
    props: {
      links: Array,
      loggedIn: Boolean,
      suggestedSearches: {
        type: Array,
        default: () => [],
      }
    },
    data () {
      return {
        subnav: null,
        overSearchResults: false,
        searchHighlighted: false,
        userHighlighted: false,
      };
    },
    computed: {
      getSearchIcon () {
        return this.searchHighlighted ? 'highlighted-search' : 'search';
      },
      getUserIcon () {
        return this.userHighlighted ? 'highlighted-user' : 'user';
      },
      // required to fix chrome throwing a invalid URL console error
      baseURL () {
        return window.location.origin;
      },
      userLink () {
        return (this.loggedIn) ? `${this.baseURL}/account` : `${this.baseURL}/account/login`;
      },
      userLabel () {
        return (this.loggedIn) ? 'My Account' : 'Log In/Sign Up';
      },
      overlayStyle () {
        return (this.subnav === 'search')
          ? { 'background-color': 'transparent' }
          : {};
      },
    },
    methods: {
      showSubnav(subnav) {
        this.subnav = subnav;
      },
      hideSearch () {
        this.$refs.searchBox.hide();
        this.hideSubnav();
      },
      onCloseResults () {
        this.hideSubnav();
      },
      hideSubnav () {
        this.subnav = null;
      },
      cleanURL (url) {
        if (url.startsWith('/')) return `${this.baseURL}${url}`;
        return url;
      },
    },
  };
</script>

<style scoped lang="scss">
  .container--nav {
    min-height: 82px;
  }

  .navbar {
    &__desktop {
      &__overlay {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        background-color: $bg--overlay;
      }

      &__wrapper {
        position: relative;
        border-bottom: 1px solid $color-lightest-grey;
        background-color: $color-white;
        transition: 0.3s ease all;

        & > .container--nav {
          padding-top: 9px;
          padding-bottom: 9px;
          display: flex;
          justify-content: space-between
        }
      }
    }

    &__left,
    &__right {
      display: flex;
      align-items: center;
    }

    &__right {
      position: absolute;
      right: $grid-gutter;
      top: 50%;
      transform: translateY(-50%);

      @include hd-up {
        position: static;
        top: auto;
        right: auto;
        transform: none;
      }

      &::before {
        content: '';
        box-sizing: content-box;
        position: absolute;
        right: 100%;
        height: 100%;
        width: 0;
        border-right: 0 solid white;
        transition: 0.3s ease-out;
        background: linear-gradient(to right,  rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
      }

      &.search-open::before {
        width: 4*$grid-gutter;
        border-right-width: 3*$grid-gutter;
      }
    }

    &__links {
      height: 100%;
      padding-left: 135px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    &__linklist {
      list-style: none;
      display: flex;
      padding: 0;
      margin: 0;

      &__link {
        display: flex;
        align-items: center;
        height: 32px;
        width: 32px;
        display: flex;
        justify-content: center;
        align-items: center;

        .navbar__left & {
          &:not(:last-child) {
            margin-right: 50px;
          }
        }

        .navbar__right & {
          margin-left: 18px;
        }

        &--text {
          width: auto;
        }

        &--user {
          padding: 2px;
        }

        > a {
          font-weight: bold;
          font-size: rem(18);
          white-space: nowrap;

          .icon {
            margin-left: 8px;
            vertical-align: middle;
          }

          &:hover {
            color: $color--link;

            .icon {
              fill: $color--link;
            }
          }
        }

        &::v-deep .button:hover {
          .icon {
            fill: $color--link;
          }
        }
      }
    }

    .navbar__linklist__link {
      color: $color-indigo;
    }

    &__search {
      // position: relative;
    }

    &__subnav {
      position: absolute;
      bottom: 0;
      left: 0;
      transform: translateY(100%);
      border-top: 1px solid $color-lightest-grey;
      padding: 33px 0;
      width: 100%;
      background-color: $color-white;

      &--search {
        border: 1px solid $border--lightest;
        padding: $grid-gutter;
        transition: 0.3s ease opacity;

        &:empty {
          opacity: 0;
        }
      }

      &__container {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &__link {
        font-size: rem(16);
        line-height: 1.4375;
        font-family: $font-gibson;

        &:not(:first-child) {
          margin-left: 54px;
        }

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .navbar__link {
      position: relative;
      padding: 9px 6px 7px;
      font-size: rem(16);
      line-height: 1;
      font-weight: 700;
      text-transform: uppercase;

      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        right: 100%;
        height: 2px;
        background-color: $color-indigo;
        transition: right 0.3s;
      }

      &:hover {
        &::after {
          right: 0;
        }
      }
    }
  }
</style>
